import { TableLayoutContract } from 'models'
import { UPDATE_TABLE_LAYOUT_CACHE } from 'store/actions/tableLayout.action'

interface ITableLayoutState {
    tableLayouts: TableLayoutContract[]
}

const initialState: ITableLayoutState = {
    tableLayouts: [],
}

export default function DrawerReducer(
    state: ITableLayoutState = initialState,
    action: any,
): ITableLayoutState {
    switch (action.type) {
        case UPDATE_TABLE_LAYOUT_CACHE: {
            return {
                ...state,
                tableLayouts: action.payload,
            }
        }
        default:
            return state
    }
}
